// Function component for a badge showing the general queue length of a restaurant (short, medium, long)

import { useContext } from "react";
import { ThemeContext } from "../App";

interface LengthBadgeProps {
    queueLabel: string;
    largeBadge?: boolean;
}

const LengthBadge = (props: LengthBadgeProps) => {
    const { theme } = useContext(ThemeContext);
    // Different lengths get different stylings / colorings
    let classNameAppendage = "lengthbadge--" + props.queueLabel.toLowerCase();

    // A bigger badge used in the guide page / restaurant card
    if (props.largeBadge) {
        classNameAppendage = classNameAppendage + " lengthbadge--large";
    }

    return (
        <div className={`lengthbadge ${classNameAppendage}`} id={theme}>
            <h5>{props.queueLabel.toUpperCase()}</h5>
        </div>
    );
};

export default LengthBadge;
